import React from 'react'
import PropTypes from 'prop-types'

export default function DropColumnColumn({ value }) {
  return value
}

DropColumnColumn.propTypes = {
  value: PropTypes.string
}

DropColumnColumn.defaultProps = {
  value: null
}
